const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://4677dnnupg.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://xfpblxxclb.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.staging.barrick.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.barrick.forwoodsafety.com',
    WEBSOCKET: 'wss://mdwceyl46c.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;
